import React, { useState, createContext, useEffect, useContext } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState({
    logado: false,
    token: null,
    usuario: {},
  });

  useEffect(() => {
    carregarSessao();
  }, []);

  const carregarSessao = async () => {
    setLoading(true);
    try {
      const value = Cookies.get("web_curriculos");
      if (value !== null) {
        setSession(JSON.parse(value));
      }
    } catch (e) {}
    setLoading(false);
  };

  const iniciarSessao = async (data) => {
    setLoading(true);
    setSession({
      ...session,
      logado: data?.logado,
      usuario: data?.usuario,
      token: data?.token,
    });

    Cookies.set(
      "web_curriculos",
      JSON.stringify({
        ...session,
        logado: data?.logado,
        usuario: data?.usuario,
        token: data?.token,
      })
    );
    setLoading(false);
  };

  const atualizarDados = async (usuario) => {
    setSession({ ...session, usuario: usuario });

    Cookies.set(
      "web_curriculos",
      JSON.stringify({
        ...session,
        usuario: usuario,
      })
    );
  };

  const encerrarSessao = async () => {
    setSession({ ...session, logado: false, usuario: {}, token: null });
    Cookies.remove("web_curriculos");
  };

  return (
    <AuthContext.Provider
      value={{
        session,
        loading,
        iniciarSessao,
        encerrarSessao,
        atualizarDados,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  return useContext(AuthContext);
};

export { AuthContextProvider, useAuth };
